import React from 'react';

import BlueCheckmark from '~/assets/icons/BlueCheckmark';

import SocialStrip from './SocialIconStrip';
import { type Group, SOCIAL_HANDLES } from './SocialMediaLinks';

type Props = {
  className?: string;
  group: Group;
  icon: React.ReactNode;
};

export default function SocialMediaCard({
  className = 'min-w-[156px] flex-1 xs:min-w-[180px] md:w-[456px] md:flex-none',
  group,
  icon
}: Props) {
  const handle = SOCIAL_HANDLES[group];

  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 rounded-lg bg-grey-panel p-4 md:flex-row md:gap-8 md:px-8 md:py-4 ${className}`}
    >
      <div className="flex flex-col items-center gap-1 md:flex-row md:gap-4">
        {icon}
        <div className="flex flex-row items-center gap-1">
          {handle}
          <BlueCheckmark />
        </div>
      </div>
      <div className="flex flex-col md:flex-row">
        <SocialStrip group={group} />
      </div>
    </div>
  );
}
